var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLangHi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_25759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12 -0.000152588H60V47.9998H-12V-0.000152588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12 -0.000152588H60V15.9998H-12V-0.000152588Z",
    fill: "#FFB44B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12 31.9987H60V47.9987H-12V31.9987Z",
    fill: "#019842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9981 31.3998C28.0851 31.3998 31.3981 28.0867 31.3981 23.9998C31.3981 19.9129 28.0851 16.5998 23.9981 16.5998C19.9112 16.5998 16.5981 19.9129 16.5981 23.9998C16.5981 28.0867 19.9112 31.3998 23.9981 31.3998Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9991 30.3992C27.5337 30.3992 30.3991 27.5338 30.3991 23.9992C30.3991 20.4646 27.5337 17.5992 23.9991 17.5992C20.4645 17.5992 17.5991 20.4646 17.5991 23.9992C17.5991 27.5338 20.4645 30.3992 23.9991 30.3992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 25.2797C24.7071 25.2797 25.2802 24.7067 25.2802 23.9997C25.2802 23.2928 24.7071 22.7197 24.0002 22.7197C23.2933 22.7197 22.7202 23.2928 22.7202 23.9997C22.7202 24.7067 23.2933 25.2797 24.0002 25.2797Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0042 17.6006L24.2442 21.4518L24.0042 23.3587L23.7642 21.4518L24.0042 17.6006Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8031 17.9328C24.9565 17.953 25.0971 17.8451 25.1173 17.6918C25.1375 17.5384 25.0296 17.3978 24.8762 17.3776C24.7229 17.3574 24.5823 17.4654 24.5621 17.6187C24.5419 17.772 24.6498 17.9126 24.8031 17.9328Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0046 30.3999L23.7646 26.5486L24.0046 24.6418L24.2446 26.5486L24.0046 30.3999Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2056 30.0676C23.0523 30.0474 22.9117 30.1553 22.8915 30.3087C22.8713 30.462 22.9792 30.6026 23.1326 30.6228C23.2859 30.643 23.4265 30.5351 23.4467 30.3818C23.4669 30.2284 23.359 30.0878 23.2056 30.0676Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6566 17.8186L24.8917 21.6008L24.1663 23.3805L24.428 21.4765L25.6566 17.8186Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3437 18.3481C26.4866 18.4073 26.6504 18.3394 26.7095 18.1966C26.7687 18.0537 26.7009 17.8899 26.558 17.8307C26.4151 17.7715 26.2513 17.8394 26.1922 17.9823C26.133 18.1251 26.2008 18.2889 26.3437 18.3481Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3458 30.1834L23.1108 26.4012L23.8361 24.6214L23.5744 26.5254L22.3458 30.1834Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6587 29.6544C21.5159 29.5953 21.3521 29.6631 21.2929 29.806C21.2337 29.9488 21.3016 30.1126 21.4444 30.1718C21.5873 30.231 21.7511 30.1631 21.8103 30.0203C21.8695 29.8774 21.8016 29.7136 21.6587 29.6544Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2005 18.4564L25.4827 21.9117L24.3215 23.443L25.067 21.6717L27.2005 18.4564Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7245 19.1436C27.8472 19.2378 28.0229 19.2146 28.1171 19.0919C28.2112 18.9693 28.1881 18.7935 28.0654 18.6994C27.9427 18.6052 27.7669 18.6284 27.6728 18.751C27.5787 18.8737 27.6018 19.0495 27.7245 19.1436Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.797 29.5422L22.5148 26.0869L23.6761 24.5555L22.9305 26.3269L20.797 29.5422Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2731 28.8549C20.1504 28.7608 19.9746 28.7839 19.8805 28.9066C19.7863 29.0293 19.8095 29.205 19.9322 29.2992C20.0548 29.3933 20.2306 29.3702 20.3248 29.2475C20.4189 29.1248 20.3957 28.949 20.2731 28.8549Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5271 19.4765L25.9736 22.3695L24.4555 23.5481L25.6342 22.0301L28.5271 19.4765Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8575 20.2767C28.9517 20.3994 29.1274 20.4225 29.2501 20.3284C29.3728 20.2342 29.3959 20.0584 29.3018 19.9358C29.2077 19.8131 29.0319 19.7899 28.9092 19.8841C28.7865 19.9782 28.7634 20.154 28.8575 20.2767Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4768 28.527L22.0303 25.6341L23.5484 24.4554L22.3697 25.9735L19.4768 28.527Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1469 27.7269C19.0527 27.6042 18.877 27.5811 18.7543 27.6752C18.6316 27.7694 18.6085 27.9451 18.7026 28.0678C18.7967 28.1905 18.9725 28.2136 19.0952 28.1195C19.2179 28.0254 19.241 27.8496 19.1469 27.7269Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5443 20.8007L26.329 22.9342L24.5576 23.6798L26.089 22.5185L29.5443 20.8007Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6562 21.6585C29.7154 21.8013 29.8792 21.8692 30.022 21.81C30.1649 21.7508 30.2327 21.587 30.1736 21.4442C30.1144 21.3013 29.9506 21.2335 29.8077 21.2926C29.6649 21.3518 29.597 21.5156 29.6562 21.6585Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4596 27.2004L21.6749 25.067L23.4463 24.3214L21.9149 25.4827L18.4596 27.2004Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3472 26.3416C18.2881 26.1987 18.1243 26.1308 17.9814 26.19C17.8385 26.2492 17.7707 26.413 17.8299 26.5559C17.889 26.6987 18.0528 26.7666 18.1957 26.7074C18.3386 26.6482 18.4064 26.4844 18.3472 26.3416Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1798 22.3418L26.5219 23.5704L24.6179 23.8321L26.3976 23.1067L30.1798 22.3418Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0653 23.1989C30.0855 23.3523 30.2262 23.4602 30.3795 23.44C30.5328 23.4198 30.6407 23.2792 30.6205 23.1258C30.6003 22.9725 30.4597 22.8646 30.3064 22.8848C30.1531 22.905 30.0451 23.0456 30.0653 23.1989Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8207 25.655L21.4786 24.4264L23.3826 24.1646L21.6029 24.89L17.8207 25.655Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9352 24.7972C17.915 24.6439 17.7743 24.536 17.621 24.5562C17.4677 24.5764 17.3598 24.717 17.38 24.8703C17.4001 25.0237 17.5408 25.1316 17.6941 25.1114C17.8474 25.0912 17.9554 24.9506 17.9352 24.7972Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3984 23.9985L26.5472 24.2385L24.6403 23.9985L26.5472 23.7585L30.3984 23.9985Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0669 24.7979C30.0468 24.9512 30.1547 25.0918 30.308 25.112C30.4613 25.1322 30.602 25.0243 30.6221 24.871C30.6423 24.7176 30.5344 24.577 30.3811 24.5568C30.2278 24.5366 30.0871 24.6445 30.0669 24.7979Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5991 24.0009L21.4504 23.7609L23.3572 24.0009L21.4504 24.2409L17.5991 24.0009Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9306 23.2016C17.9508 23.0482 17.8429 22.9076 17.6896 22.8874C17.5362 22.8672 17.3956 22.9751 17.3754 23.1285C17.3552 23.2818 17.4632 23.4224 17.6165 23.4426C17.7698 23.4628 17.9104 23.3549 17.9306 23.2016Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.184 25.6556L26.4018 24.8906L24.6221 24.1653L26.5261 24.427L30.184 25.6556Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6572 26.3421C29.598 26.4849 29.6659 26.6487 29.8087 26.7079C29.9516 26.7671 30.1154 26.6992 30.1746 26.5564C30.2338 26.4135 30.1659 26.2497 30.0231 26.1905C29.8802 26.1313 29.7164 26.1992 29.6572 26.3421Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.816 22.3441L21.5982 23.1091L23.3779 23.8344L21.4739 23.5727L17.816 22.3441Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3457 21.6583C18.4049 21.5154 18.337 21.3516 18.1942 21.2924C18.0513 21.2332 17.8875 21.3011 17.8283 21.444C17.7692 21.5868 17.837 21.7506 17.9799 21.8098C18.1227 21.869 18.2865 21.8011 18.3457 21.6583Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5402 27.2003L26.0849 25.4825L24.5535 24.3212L26.3249 25.0668L29.5402 27.2003Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.853 27.7258C28.7589 27.8485 28.782 28.0243 28.9047 28.1184C29.0274 28.2126 29.2032 28.1894 29.2973 28.0667C29.3915 27.9441 29.3683 27.7683 29.2456 27.6742C29.123 27.58 28.9472 27.6032 28.853 27.7258Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4569 20.8012L21.9122 22.519L23.4436 23.6803L21.6722 22.9347L18.4569 20.8012Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.144 20.2757C19.2382 20.153 19.215 19.9772 19.0923 19.8831C18.9697 19.789 18.7939 19.8121 18.6998 19.9348C18.6056 20.0575 18.6288 20.2332 18.7514 20.3274C18.8741 20.4215 19.0499 20.3984 19.144 20.2757Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5295 28.5243L25.6365 25.9707L24.4579 24.4527L25.976 25.6313L28.5295 28.5243Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7285 28.8536C27.6058 28.9478 27.5826 29.1235 27.6768 29.2462C27.7709 29.3689 27.9467 29.392 28.0694 29.2979C28.192 29.2038 28.2152 29.028 28.1211 28.9053C28.0269 28.7826 27.8511 28.7595 27.7285 28.8536Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4754 19.4756L22.3683 22.0291L23.547 23.5472L22.0289 22.3686L19.4754 19.4756Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 19.1462C20.3991 19.0521 20.4222 18.8763 20.3281 18.7536C20.234 18.631 20.0582 18.6078 19.9355 18.702C19.8128 18.7961 19.7897 18.9719 19.8838 19.0945C19.978 19.2172 20.1537 19.2404 20.2764 19.1462Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1969 29.5431L25.0635 26.3278L24.3179 24.5564L25.4791 26.0878L27.1969 29.5431Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3366 29.6552C26.1937 29.7144 26.1259 29.8782 26.185 30.021C26.2442 30.1639 26.408 30.2318 26.5509 30.1726C26.6938 30.1134 26.7616 29.9496 26.7024 29.8067C26.6432 29.6639 26.4794 29.596 26.3366 29.6552Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7957 18.457L22.9292 21.6723L23.6748 23.4437L22.5135 21.9123L20.7957 18.457Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6561 18.3444C21.799 18.2852 21.8668 18.1214 21.8076 17.9786C21.7485 17.8357 21.5847 17.7678 21.4418 17.827C21.2989 17.8862 21.2311 18.05 21.2903 18.1929C21.3494 18.3357 21.5132 18.4036 21.6561 18.3444Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.65 30.184L24.4214 26.5261L24.1597 24.6221L24.8851 26.4018L25.65 30.184Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7929 30.0692C24.6395 30.0894 24.5316 30.23 24.5518 30.3833C24.572 30.5366 24.7126 30.6446 24.866 30.6244C25.0193 30.6042 25.1272 30.4635 25.107 30.3102C25.0868 30.1569 24.9462 30.049 24.7929 30.0692Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3427 17.8197L23.5713 21.4776L23.833 23.3816L23.1076 21.6018L22.3427 17.8197Z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1993 17.935C23.3526 17.9149 23.4606 17.7742 23.4404 17.6209C23.4202 17.4676 23.2796 17.3596 23.1262 17.3798C22.9729 17.4 22.865 17.5407 22.8852 17.694C22.9054 17.8473 23.046 17.9552 23.1993 17.935Z",
    fill: "#07038D"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#E8E9F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_25759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangHi);
export default __webpack_public_path__ + "static/media/lang_hi.adc31f6ee2b41c7f8ad931b7a83a0467.svg";
export { ForwardRef as ReactComponent };